var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoQueueGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540.8 160.8C517.6 160.8 497.6 177.6 489.6 200.8C520 214.4 543.2 244 551.2 280C576 274.4 594.4 250.4 594.4 221.6C594.4 187.2 570.4 160.8 540.8 160.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M590.4 303.2C580 312.8 567.2 319.2 552.8 321.6C550.4 343.2 542.4 363.2 530.4 379.2H619.2C630.4 379.2 639.2 370.4 639.2 359.2V349.6C639.2 328 615.2 314.4 590.4 303.2Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M505.6 400C489.6 414.4 469.6 423.2 448 423.2C446.4 448 439.2 470.4 428 489.6H540C552.8 489.6 564 479.2 564 465.6V456C563.2 429.6 534.4 413.6 505.6 400Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M402.4 521.6C380 544 349.6 556.8 317.6 556.8C284.8 556.8 254.4 543.2 232 520C195.2 537.6 160 560 160 592.8V608C160 625.6 174.4 639.2 191.2 639.2H441.6C459.2 639.2 472.8 624.8 472.8 608V593.6C472.8 560 439.2 538.4 402.4 521.6Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8 507.2C364.076 507.2 402.4 464.936 402.4 412.8C402.4 360.664 364.076 318.4 316.8 318.4C269.524 318.4 231.2 360.664 231.2 412.8C231.2 464.936 269.524 507.2 316.8 507.2Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M445.6 236C416 236 391.2 257.6 384 288C413.6 307.2 435.2 340 444 377.6C444.8 377.6 444.8 377.6 445.6 377.6C480.8 377.6 509.6 345.6 509.6 306.4C510.4 268 481.6 236 445.6 236Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQueueGreen);
export default __webpack_public_path__ + "static/media/ico_queue_green.f942a3f8f76dbd32997561d6d9338701.svg";
export { ForwardRef as ReactComponent };